import http from "@/http/http.js";

let baseURL = '';
if (process.env.NODE_ENV == 'development') {
    //开发环境
    baseURL = '/api/web/auth/accessAuth/springBoard';
} else if (process.env.NODE_ENV == 'production') {
    //生产环境
    baseURL = '/web/auth/accessAuth/springBoard';
}


let baseURL2 = '';
if (process.env.NODE_ENV == 'development') {
    //开发环境
    baseURL2 = '/api/web/opaction/order/springBoard';
} else if (process.env.NODE_ENV == 'production') {
    //生产环境
    baseURL2 = '/web/opaction/order/springBoard';
}


let baseURL3 = '';
if (process.env.NODE_ENV == 'development') {
    //开发环境
    baseURL3 = '/api/web/opaction/360tmOrder/springBoard';
} else if (process.env.NODE_ENV == 'production') {
    //生产环境
    baseURL3 = '/web/opaction/360tmOrder/springBoard';
}

//360 pin 返回userpin
export function channelUserLogin(params) {
    return http.post(baseURL, {
        actionBody: params,
        actionType: 'channelUserLogin',
    });
}

//创建订单
export function addOrder(params) {
    return http.post(baseURL2, {
        actionBody: params,
        actionType: 'addOrder',
    });
}

//获取参数 传给360
export function getParamsFor360(params) {
    return http.post(baseURL3, {
        actionBody: {
            orderNo:params
        },
        actionType: 'getParamsFor360',
    });
}